// apps/web/src/components/Layout.tsx

import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import BottomNavigation from "@/components/BottomNavigation";
import Sidebar from "@/components/Sidebar";
import { useSocket } from "@/hooks/useSocket";
import { useAuthStore } from "@/store/authStore";

const Layout = () => {
  // Activate real-time notifications for logged-in users
  useSocket();

  const { user } = useAuthStore();
  const location = useLocation();

  // ═══════════════════════════════════════════════════════════════════════════
  // SMART LAYOUT LOGIC
  // ═══════════════════════════════════════════════════════════════════════════

  // Routes where we should show neither footer nor navigation
  const noNavigationRoutes = [
    '/onboarding',
    '/login',
    '/register',
  ];

  // Public routes where footer should show (for non-logged users)
  const publicRoutes = [
    '/',
    '/about-us',
    '/contact',
    '/privacy-policy',
    '/terms-of-service',
    '/how-it-works',
    '/faq',
  ];

  const shouldHideNavigation = noNavigationRoutes.some(route =>
    location.pathname.startsWith(route)
  );

  // Determine what to show
  const showSidebar = user && !shouldHideNavigation; // Desktop sidebar for logged-in users
  const showBottomNav = user && !shouldHideNavigation; // Mobile bottom nav for logged-in users
  const showFooter = !user && (
    publicRoutes.includes(location.pathname) ||
    location.pathname === '/jobs' ||
    location.pathname.match(/^\/jobs\/[^/]+$/) ||
    location.pathname.startsWith('/blog')
  );

  return (
    <div className="min-h-screen bg-background flex">
      {/* Desktop Sidebar (hidden on mobile) */}
      {showSidebar && <Sidebar />}

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <main className={`flex-grow pt-16 ${showBottomNav ? 'pb-20 md:pb-0' : ''}`}>
          <Outlet />
        </main>

        {/* Show footer for non-logged users on public pages */}
        {showFooter && <Footer />}
      </div>

      {/* Mobile Bottom Navigation (hidden on desktop) */}
      {showBottomNav && <BottomNavigation />}
    </div>
  );
};


export default Layout;